import React, { FC, useMemo, ReactNode, useState } from 'react';
import SubscriptionModel, { isSubscription } from '../../../models/SubscriptionModel';
import AccordionTextItem from '../../Accordion/AccordionTextItem/AccordionTextItem';
import AccordionListItem from '../../Accordion/AccordionListItem/AccordionListItem';
import useAuth from '../../../hooks/useAuth';
import FullView from '../FullView';
import Accordion from '../../Accordion/Accordion';
import _ from 'lodash';
import styled from './LawLibraryFullView.module.css';
import LawModel from '../../../models/LawModel';
import DetachedCopyFullViewHeader from '../../DetachedCopyFullViewHeader/DetachedCopyFullViewHeader';
import { useTranslation } from 'react-i18next';

interface Props {
    data?: SubscriptionModel | LawModel;
    open: boolean;
    onClose: () => void;
}

const LawLibraryFullView: FC<Props> = ({ data, open, onClose }) => {
    const { t, i18n } = useTranslation();
    const { company, isGroupCompany } = useAuth();

    const [openAccordions, setOpenAccordions] = useState<number[]>([]);

    const accordionItems = useMemo(() => {
        const items: { title: string; value: ReactNode }[] = [];

        items.push({
            title: t('columnDescription'),
            value: <AccordionTextItem data={data?.description || ''} />,
        });

        if (company?.hasLawLists) {
            items.push({
                title: t('columnLawLists'),
                value: <AccordionListItem data={data?.lawLists?.map(ll => (ll.lawListGroup ? ll.lawListGroup.name + ': ' : '') + ll.name) || []} />,
            });
        }

        if (company?.hasKeyWords) {
            items.push({
                title: t('columnKeywords'),
                value: <AccordionListItem data={data?.keywordIds?.map(kwId => _.find(company.keyWords, kw => kw.id === kwId)?.text || '') || []} />,
            });
        }
        return items;
    }, [data, i18n.language]);

    const handleToggleAccordion = (index: number) => {
        setOpenAccordions(s => (s.includes(index) ? s.filter(i => i !== index) : [...s, index]));
    };

    return (
        <FullView
            hiddenIdBar={data ? 'Lid:' + data?.lawId : ''}
            lawSourceId={data?.lawId}
            title={data?.name || ''}
            subId={data?.subId || ''}
            isCustomLaw={false}
            lawSource={data?.lawSources.length ? data.lawSources[0] : undefined}
            open={open}
            onClose={onClose}
            monitorButton={{
                isMonitored: data !== undefined && isSubscription(data),
                disabled: true,
                title: isGroupCompany() ? t('groupCustomerRestrictionInformation') : '',
            }}
            headerChildren={data && isSubscription(data) && data.detachedCopy && <DetachedCopyFullViewHeader withLink />}
        >
            <div className={styled.Content}>
                <Accordion id={data?.lawId || -1} data={accordionItems} initiallyOpenIndicies={openAccordions} onToggle={handleToggleAccordion} />
            </div>
        </FullView>
    );
};

export default LawLibraryFullView;
